<template>
	<v-sheet elevation="0" max-width="700px" class="mx-auto">
		<FunctionTitle :title="''" />
		<CommonFlame :title="'パスワード再設定'">
			<v-sheet elevation="0" class="mt-4">
				<v-form ref="form" v-model="valid">
					<v-text-field
						v-model="currentPassword"
						label="現在のパスワード*"
						class="mt-4"
						type="password"
						:rules="[rules.required, rules.passwordMin]"
						required
						dense
						outlined
					></v-text-field>
					<v-text-field
						v-model="newPassword"
						label="新しいパスワード*"
						class="mt-4"
						type="password"
						hint="英大文字・小文字・数字を含む8文字以上で入力して下さい"
						:rules="[rules.required, rules.passwordMin]"
						required
						dense
						outlined
					></v-text-field>
					<v-text-field
						v-model="newPasswordConfirmation"
						label="新しいパスワード（確認用）*"
						class="mt-4"
						type="password"
						hint="確認用にパスワードを再度入力して下さい"
						:rules="[rules.required, rules.passwordMin]"
						required
						dense
						outlined
					></v-text-field>
					<ul class="error-message" v-if="errors.length">
						<li v-for="(error, i) in errors" :key="i">
							{{ error }}
						</li>
					</ul>
					<v-row justify="center" class="my-4">
						<v-btn @click="updatePassword" color="secondary" :disabled="!valid">
							パスワードを再設定する
						</v-btn>
					</v-row>
				</v-form>
			</v-sheet>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import axios from "axios"
import rules from "../../helper/rules"
import errorHandling from "../../helper/errorHandling"
import authenticate from "../../helper/authenticate"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"


export default {
	components: { FunctionTitle, CommonFlame },
	data() {
		return {
			valid: false,
			currentPassword: null,
			newPassword: null,
			newPasswordConfirmation: null,
			errors: [],
			rules: rules,
		}
	},
	methods: {
		updatePassword() {
			const headers = authenticate.setHeader()

			this.errors = []
			if (!this.$refs.form.validate()) return
			axios
				.put(
					`/erp/v1/passwords`,
					{
						password: this.newPassword,
						password_confirmation: this.newPasswordConfirmation,
						current_password: this.currentPassword,
					},
					{ headers }
				)
				.then((res) => {
					this.$store.dispatch("setFlash", {
						text: "パスワード再設定がされました。再度ログインしてください",
						type: "notice",
					})
					this.$store.dispatch("auth/logOut")
					this.$router.push("/erp/login")
				})
				.catch((err) => {
					const error = errorHandling.errorResponse(err)
					if (Array.isArray(error)) {
						this.errors = error
					}
				})
		},
	},
}
</script>

<style lang="scss" scoped>
.wrapper {
	background-color: white;
}
.main-container {
	width: 100%;
	max-width: 600px;
	margin: 0 auto;
}
</style>
